import * as React from 'react';

import {Body} from 'shells/typography/body';
import {Header} from 'shells/typography/header';
import {Subheader} from 'shells/typography/subheader';

import type {LoginVariant} from '../login-page';

import {LoginFlowButton} from './login-flow-button';

import styles from '../login-form.module.css';

type Props = {
    emailValue: string | null | undefined;
    ssoRedirectUrl: string | null | undefined;
    setVariant: (variant: LoginVariant) => void;
};

export function ChooseMethodPage(props: Props) {
    return (
        <>
            <Header>Sign in</Header>
            <Subheader>
                You are signing in as{' '}
                <Body size='large' wrapAnywhere={true}>
                    {props.emailValue}
                </Body>
            </Subheader>
            <div className='flex flex-dir-col gap-0'>
                <LoginFlowButton
                    bttnVariant='primary'
                    onClick={() => {
                        // @ts-expect-error
                        window.location.replace(props.ssoRedirectUrl);
                    }}
                >
                    Continue with SSO
                </LoginFlowButton>
                <div className={styles['link-button']}>
                    <LoginFlowButton
                        bttnVariant='text-primary'
                        onClick={() => {
                            props.setVariant('password');
                        }}
                    >
                        Continue with password
                    </LoginFlowButton>
                </div>
            </div>
        </>
    );
}
